/* eslint-disable no-restricted-imports */
import {
  Provider, /* shallowEqual, ReactReduxContext, ReactReduxContextValue, createDispatchHook, useStore, createStoreHook,
  ProviderProps, createSelectorHook, */
} from 'react-redux';
import { useSelector as useOriginSelector } from '@anwhy/reselect-utils';

const useSelector = useOriginSelector;

export {
  Provider,
  // ReactReduxContext,
  // createDispatchHook,
  useSelector,
  // createSelectorHook,
  // useStore,
  // createStoreHook,
  // shallowEqual,
};

// export type { ProviderProps, ReactReduxContextValue };
export { useDispatch } from './_hooks/useDispatch';
